export const SET_AUTH_DATA = 'SET_AUTH_DATA';
export const CLEAR_AUTH_DATA = 'CLEAR_AUTH_DATA';
export const INCREMENT_KEY = 'INCREMENT_KEY';

export const setAuthDataAction = data => ({ type: SET_AUTH_DATA, data });
export const clearAuthDataAction = () => ({ type: CLEAR_AUTH_DATA });
export const incrementKeyAction = () => ({ type: INCREMENT_KEY });
